<template>
  <div class="fabric-container grid bg-white">
    <router-link
      tag="div"
      class="grid-body fabric-card"
      :to="{ name: 'fabric_update', params: { id: fabric.id } }"
    >
      <img
        :src="fabric.image_url"
        class="image"
        alt=""
        v-if="fabric.image_url"
      />
      <img
        src="/assets/img/fabric-placeholder.png"
        class="image"
        alt=""
        v-else
      />
    </router-link>
    <div class="grid-title">
      <h4>{{ $Fabric.getCode(fabric.id) }}</h4>
      <h3 class="text-capitalize semi-bold">{{ fabric.name }}</h3>
      <div class="btn-group fabric-dropdown">
        <button
          class="btn btn-default dropdown-toggle btn-demo-space"
          data-toggle="dropdown"
        >
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu pull-right">
          <li>
            <router-link :to="{ path: '/fabric/update/' + fabric.id }"
              >Edit</router-link
            >
          </li>
          <li>
            <router-link
              :to="{
                name: 'fabric_roll_withdraw',
                params: { fabric_id: fabric.id },
              }"
              >Withdraw</router-link
            >
          </li>
          <li>
            <router-link
              :to="{
                name: 'fabric_roll_roll_log',
                params: { fabric_id: fabric.id },
              }"
              >View Logs</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fabric"],
  data() {
    return {};
  },
};
</script>
<style scoped>
.fabric-container .grid-title {
  border-top: 1px solid #eee !important;
}

.fabric-container .image {
  width: 100%;
  height: 200px;
}

.fabric-container .text-capitalize {
  text-transform: uppercase;
}

.fabric-container h3 {
  margin-top: 0px;
  margin-bottom: 15px;
}

.fabric-container h4 {
  margin-bottom: 0px;
}

.fabric-container .fabric-dropdown {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.fabric-card {
  max-height: 235px !important;
  min-height: 235px;
}
</style>
